import UtilsFormule from "../../../utils/UtilsFormule";
import React from "react";


const CardSolde=({idSociete,idAccount,title,typeSociete,solde,lastUpdateDate})=>{


  const details = () => {
    localStorage.setItem("idTiers",idSociete)
    localStorage.setItem("idAccountSolde",idAccount)
    
    if(localStorage.getItem("TypeTiersAccount")==="C"){
      const pdfWindow = window.open();
          pdfWindow.location.href = "/detailsTransactionAccountClient";

    }else if(localStorage.getItem("TypeTiersAccount")==="F"){
      const pdfWindow = window.open();
      pdfWindow.location.href = "/detailsTransactionAccountFournisseur";

    }
  };
    return ( <div className="card card-outline card-dark">
    <div class="card-header">
      <h3 class="card-title">Solde {typeSociete} </h3>
      <div class="card-tools">
        Dernière mise à jour à {UtilsFormule.formatDate(lastUpdateDate )}
       
      </div>
    </div>
    <div className="card-body">
      <div className="form-group files color">
        <div class="row">
          <div class="col-md-12">
            <label>
              {title} est de {solde} DNT
            </label>
          </div>
          <div className="col-md-12">
            <button
              className="btn btn-dark float-right"
              onClick={(e) => details(e)}
            >
              <i class="fas fa-eye"></i> Détails
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>)



}
export default CardSolde;